import React from "react";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import InstagramIcon from "@mui/icons-material/Instagram";
import PublicRoundedIcon from "@mui/icons-material/PublicRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import TwitterIcon from "@mui/icons-material/Twitter";
import { Link as RouterLink } from "react-router-dom";
import SecureConnected from "../components/SecureConnected";
import { SiteFooter, SiteHeader } from "../components/SiteChrome";
import useScrollReveal from "../hooks/useScrollReveal";
import "./News.css";

const stories = [
  {
    badge: "Trending",
    tag: "News",
    type: "news",
    title: "trilLOAN Reaches ₱10 Billion in Total Loans Facilitated",
  },
  {
    tag: "Product",
    type: "product",
    title: "trilLOAN Reaches ₱10 Billion in Total Loans Facilitated",
  },
];

export default function News() {
  useScrollReveal();

  return (
    <main className="news-page">
      <SiteHeader />

      <section className="news-page-hero tl-reveal">
        <div className="news-page-heading">
          <h1>Latest News & Updates</h1>
          <p>
            Stay informed about trilLOAN's latest features, partnerships, and
            insights to help you make the most of your financial journey.
          </p>
        </div>

        <label className="news-search">
          <SearchRoundedIcon />
          <input type="search" placeholder="Search for news, updates, tips..." />
        </label>

        <section className="featured-stories" aria-labelledby="featured-stories-title">
          <h2 id="featured-stories-title">Featured Stories</h2>
          <div className="featured-story-grid">
            {stories.map((story, index) => (
              <article className={`tl-reveal tl-reveal-delay-${index % 2}`} key={`${story.type}-${index}`}>
                {story.badge && <span className="story-trending">{story.badge}</span>}
                <div className="story-image" aria-hidden="true">
                  <EmailOutlinedIcon />
                </div>
                <span className="story-tag">{story.tag}</span>
                <h3>{story.title}</h3>
                <p>
                  A major milestone that showcases the growing trust of Filipino
                  borrowers and lenders in our platform.
                </p>
                <div className="story-footer">
                  <time>March 15, 2024</time>
                  <a href="/news">
                    Read More
                    <ArrowForwardRoundedIcon />
                  </a>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="news-follow-card tl-reveal">
          <h2>Follow Us</h2>
          <p>Stay updated with our latest news and announcements</p>
          <div>
            <a href="https://www.facebook.com/paychat.official" aria-label="Facebook">
              <FacebookRoundedIcon />
            </a>
            <a href="https://twitter.com/paychat_ph" aria-label="Twitter">
              <TwitterIcon />
            </a>
            <a href="https://www.instagram.com/paychatph/" aria-label="Instagram">
              <InstagramIcon />
            </a>
            <a href="https://official.paychat.ph/" aria-label="Website">
              <PublicRoundedIcon />
            </a>
          </div>
        </section>

        <section className="news-faq-card tl-reveal">
          <span>
            <ChatBubbleOutlineRoundedIcon />
          </span>
          <h2>Need Quick Answers?</h2>
          <p>Check our FAQ section for instant answers to common questions.</p>
          <RouterLink to="/help-center">Browse FAQ's</RouterLink>
        </section>
      </section>

      <SecureConnected />
      <SiteFooter />
    </main>
  );
}
